export default "/images/email.svg?bac42df7c8ec20eadde59fd47da2530e";